<template>
  <div class="item-detail" v-if="item"
       :style="{backgroundImage: 'url(//www.bungie.net'+item.definition.screenshot+')'}">
    <div class="close" @click="$router.back()">
      <i class="material-icons clickable">
        close
      </i>
    </div>
    <div class="column"
         :style="{backgroundImage: item.definition.secondaryIcon?'url(//www.bungie.net'+item.definition.secondaryIcon+')':''}">
      <div class="header">
        <img class="item-icon" :src="'//www.bungie.net'+item.definition.displayProperties.icon">
        <div class="definition">
          <h1>{{ item.name.toUpperCase() }}</h1>
          <h2>{{ item.definition.itemTypeDisplayName }}</h2>
        </div>
        <div class="icon equipped" v-show="item.canEquip">
          <i v-show="item.equipped" class="material-icons" @click.stop="unEquip" title="unequip">bookmark</i>
          <i v-show="!item.equipped" class="material-icons" @click.stop="equip" title="equip">bookmark_border</i>
        </div>
        <div class="icon favorite">
          <i v-show="item.favorited" class="material-icons" @click.stop="unFavorite" title="unfavorite">star</i>
          <i v-show="!item.favorited" class="material-icons" @click.stop="favorite" title="favorite">star_border</i>
        </div>
      </div>
      <p class="description">{{ item.definition.displayProperties.description }}</p>
      <div class="tokens">
        <span class="token shadow" v-for="token in item.tokens" @click="searchToken(token)">{{ token }}</span>
      </div>

      <div class="sockets">
        <div class="socket" v-for="socket in item.sockets">
          <img :src="'//www.bungie.net' + socket.displayProperties.icon" :title="socket.displayProperties.name">
          <div class="detail">
            <div class="header">
              <h1>{{ socket.displayProperties.name }}</h1>
              {{ socket.itemTypeDisplayName }}
            </div>
            <div class="body">
              {{ socket.displayProperties.description }}
            </div>
          </div>
        </div>
      </div>
      <table class="stats">
        <tr v-for="stat in item.stats" :key="stat.hash">
          <td class="label">{{ stat.definition.displayProperties.name }}</td>
          <td class="value">{{ stat.value }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ItemDetail',
    props: ['instanceId'],
    data () {
      return {}
    },
    computed: {
      item () {
        const item = this.$store.state.destiny.profile.items.find(item => item.data.itemInstanceId === this.instanceId)
        if (process.env.NODE_ENV !== 'production') {
          window.item = item
        }
        return item
      }
    },
    methods: {
      equip () {
        this.item.equip().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'equipItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      unEquip () {
        this.item.unEquip().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'unEquipItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      searchToken (newSearch) {
        this.$store.commit('destiny/filters/updateSearch', {search: newSearch})
        this.$router.back()
      },
      favorite () {
        this.$store.commit('favoriteItem', {item: this.item})
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'favorite',
          eventLabel: this.item.name,
          eventValue: 1
        })
      },
      unFavorite () {
        this.$store.commit('unFavoriteItem', {item: this.item})
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'unFavorite',
          eventLabel: this.item.name,
          eventValue: 1
        })
      }
    },
    components: {}
  }
</script>

<style scoped lang="scss">
  @import "../../styles/settings";

  .item-detail {
    position: relative;
    .close {
      position: absolute;
      right: 0.5em;
      top: 0.5em;
      .material-icons {
        font-size: 3em;
        font-weight: bold;
      }
    }

    .stats {
      text-shadow: $default-text-shadow;
      @media #{$media-phone} {
        width: 100%;
      }
      .label {
        padding-right: 1rem;
      }
      .value {
        text-align: right;
        font-weight: bold;
      }
    }
    h1, h2 {
      margin: 0;
      padding: 0;
      font-weight: 400;
      color: white;
      text-transform: uppercase;
      text-shadow: $default-text-shadow;
    }
    background-size: cover;
    background-position-x: center;
    font-size: 1rem;
    .column {
      .header {
        white-space: nowrap;
        overflow: hidden;
        display: flex;
        margin-right: 3rem;
        > * {
          vertical-align: top;
        }
        .item-icon {
          height: 49px;
          border: 1px solid white;
          margin-right: 0.5rem;
        }
        .definition {
          display: inline-block;
          overflow: hidden;
          h1 {
            margin-top: -5px;
            font-size: 35px;
            max-width: 50vh;
          }
          h2 {
            text-transform: uppercase;
            font-weight: 100;
            font-size: 15px;
          }
        }
        .material-icons {
          margin-top: -3px;
          font-size: 35px;
          cursor: pointer;
        }
      }
      .description {
        display: inline-block;
        font-style: italic;
        padding: .5rem 0;
        text-shadow: $default-text-shadow;
      }

      background-repeat: no-repeat;
      padding: 1rem;
      min-height: 100vh;
      .tokens {
        .token {
          display: inline-block;
          background-color: rgba(42, 51, 62, .6);
          padding: .5rem;
          margin: .5rem 1rem .5rem 0;
        }
      }
      .sockets {
        padding: 1rem 0;
        .socket {
          display: inline-block;
          img {
            height: 74px;
            margin-right: .5rem;
          }
          @media only screen and (min-width: 640px) {
            &:hover {
              .detail {
                display: block;
              }
            }
          }
          .detail {
            position: absolute;
            display: none;
            border-top: 5px solid rgba(255, 255, 255, 0.9);
            width: 350px;
            .header {
              background: rgba(0, 0, 0, .8);
              padding: .5rem;
            }
            .body {
              background: rgba(50, 50, 50, .8);
              padding: .5rem;
            }
            h1 {
              margin: 0;
              font-weight: bold;
              color: white;
              display: block;
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// ItemDetail.vue?25e964a2